import { render, staticRenderFns } from "./ReviewYourAnswersWR.vue?vue&type=template&id=b6818498"
import script from "./ReviewYourAnswersWR.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersWR.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports